<div class="m-x-md cipo--height--full">
    <app-data-list-command [filters]="filters" (filtersToApplyChange)="search($event)">
        @if (isinfiniteScroll()) {
            <cipo-infinite-data-list
                [tableColumns]="tableColumns"
                [tableData]="tableData()"
                class="data-list"
                primaryKey="entityInstanceId"
                [options]="tableOptions()"
                (sortChanged)="handleSort($event)"
                (paginationUpdated)="handlePagination($event)"
                (rowClicked)="openPopup($event)" />
        } @else {
            <cipo-paged-data-list
                [tableColumns]="tableColumns"
                [tableData]="tableData()"
                class="data-list"
                primaryKey="entityInstanceId"
                [options]="tableOptions()"
                (sortChanged)="handleSort($event)"
                (paginationUpdated)="handlePagination($event)"
                (rowClicked)="openPopup($event)" />
        }
    </app-data-list-command>
</div>
